{
  /*Color names are referenced from https://www.schemecolor.com/sample */
}

// Light theme colors (existing)
export const lightColors = {
  black87: 'rgba(0, 0, 0, 0.87)',
  black78: 'rgba(0, 0, 0, 0.24)',
  lightGray10: 'rgba(217, 217, 217, 1)',
  dimGray10: 'rgba(148, 148, 148, 1)',
  gray80: 'rgba(129, 125, 125, 0.80)',
  black59: '#00000059',
  black85: 'rgba(0, 0, 0, 0.85)',
  black60: 'rgba(0, 0, 0, 0.60)',
  black54: 'rgba(0, 0, 0, 0.54)',
  black50: 'rgba(0, 0, 0, 0.50)',
  black75: 'rgba(0, 0, 0, 0.75)',
  black70: 'rgba(0, 0, 0, 0.70)',
  black45: 'rgba(0, 0, 0, 0.45)',
  black40: 'rgba(0, 0, 0, 0.4)',
  black30: 'rgba(0, 0, 0, 0.3)',
  black35: 'rgba(0, 0, 0, 0.35)',
  black34: 'rgba(0, 0, 0, 0.34)',
  black25: 'rgba(0, 0, 0, 0.25)',
  black15: 'rgba(0, 0, 0, 0.15)',
  black20: 'rgba(0, 0, 0, 0.2)',
  black10: 'rgba(0, 0, 0, 0.10)',
  black5: 'rgba(0, 0, 0, 0.05)',
  black3: 'rgba(0, 0, 0, 0.03)',
  black2: 'rgba(0, 0, 0, 0.02)',
  black1: 'rgba(0, 0, 0, 0.01)',
  blueShadow: 'rgba(69, 81, 87, 0.2)',
  paleWhite10: 'rgba(251, 251, 251, 1)',
  white10: 'rgba(255, 255, 255, 1)',
  white1: 'rgba(255, 255, 255, 0.01)',
  white50: 'rgba(255, 255, 255, 0.5)',
  white20: 'rgba(255, 255, 255, 0.2)',
  dividerBorder: 'rgb(220, 220, 220)',
  groupDivider: 'rgb(250, 250, 250)',
  grayBorder: 'rgba(181, 181, 181, 1)',
  philippineGray10: 'rgba(140, 140, 140, 1)',
  selectedBg: 'rgba(83, 136, 216, 0.05)',
  iconBlue: 'rgba(83, 136, 216, 1)',
  semiTransparentBlack2: '#0000008A',
  black: '#000000',
  CadetBlue: '#5c9a76',
  white: '#FFFFFF',
  azureishWhite: '#D6E6FF',
  paleWhite: '#FBFBFBFB',
  black57: '#00000057',
  black4: '#00000040',
  lotion: '#FAFAFA',
  lavenderBlush: '#FFF3F3',
  jellyBean: '#D85353',
  greySeaShell: '#F1F1F1',
  greySaturated: '#FDFDFD',
  gray10: '#F2F2F2',
  gray99: '#FCFCFC',
  greyMercury: '#E6E6E6',
  greyText: '#777777',
  greyBorder: '#D7D7D7',
  greyBackground: '#F7F7F7',
  eclipse: '#3a3a3a',
  green10: '#47815a',
  ChateauGreen: '#4AA163',
  red: '#D74E4E',
  success: '#3B953E',
  sandGray: '#313131',
  classicGreen: '#3aaa3a',
  maniacGreen: '#009100',
  grayPlaceholder: '#CCCCCC',
  danger: '#EB5757',
  grayLine: '#EEEEEE',
  info: '#58C8FD',
  potterBlue: '#3a3aaa',
  backgroundLight: '#F8F8F8',
  blueMagenta: '#1D1D1F',
  grayDescription: '#8C8C8C',
  warning: '#EEA345',
  title: '#AAAAAA',
  whiteSmoke: '#f5f5f5',
  gray88: '#e0e0e0',
  gray74: '#bdbdbd',
  gray62: '#9e9e9e',
  silverSonic: '#757575',
  grayDim: '#616161',
  gray92: '#ebebeb',
  gray26: '#424242',
  gray13: '#212121',
  grayd9: '#D9D9D9',
  gray: '#808080',
  charcoal: '#333333',
  blueBorder: '#5388D8',
  linkBackground: '#D6E6FF',
  activeBtn: '#F5F9FF',
  hoverMenu: '#E3EEFF',
  cyanBlue: '#ced4da',
  hoverBlue: '#EFF3FF',
  darkBlue: '#1e88e5',
  grayBackground: '#fbfbfb',
  magnolia: '#F4FAFE',
  gray11: '#1c1c1c',
  oldSilver: '#848484',
  darkSilver: '#6F6F6F',
  lightBlueText: 'rgb(66, 165, 245)',
  electricBlue: '#6CF3E9',
  grayLight: '#5A5A5A',
  silverChalice: '#adaaaa',
  doveGray: '#656565',
  delGreen: '#4aa163',
  redLight: '#f94e4e',
  transparentBlack: 'rgba(0, 0, 0, 0.04)',
  transparentWhite: 'rgba(255, 255, 255, 0.1)',
  chineseSilver: '#CBCBCB',
  lightgray: '#EFEFEF',
  borderBlue: '#00C4FF',
  lineGray: '#CECECE',
  dodgerBlue: '#1890ff',
  dimGray: 'rgb(96, 96, 96)',
  gunmetal: '#383838',
  yellowishBrown: '#847C3A',
  darkGray: 'rgba(51, 51, 51)',
  darkWashedRed: 'rgba(200, 30, 30, 0)',
  alto: '#DFDFDF',
};

// Dark theme colors
export const darkColors = {
  // Base colors - inverted from light theme
  black87: 'rgba(255, 255, 255, 0.87)',
  black78: 'rgba(255, 255, 255, 0.78)',
  black70: 'rgba(255, 255, 255, 0.70)',
  black60: 'rgba(255, 255, 255, 0.60)',
  black54: 'rgba(255, 255, 255, 0.54)',
  black50: 'rgba(255, 255, 255, 0.50)',
  black45: 'rgba(255, 255, 255, 0.45)',
  black40: 'rgba(255, 255, 255, 0.40)',
  black35: 'rgba(255, 255, 255, 0.35)',
  black34: 'rgba(255, 255, 255, 0.34)',
  black30: 'rgba(255, 255, 255, 0.30)',
  black25: 'rgba(255, 255, 255, 0.25)',
  black20: 'rgba(255, 255, 255, 0.20)',
  black15: 'rgba(255, 255, 255, 0.15)',
  black10: 'rgba(255, 255, 255, 0.10)',
  black5: 'rgba(255, 255, 255, 0.05)',
  black3: 'rgba(255, 255, 255, 0.03)',
  black2: 'rgba(255, 255, 255, 0.02)',
  black1: 'rgba(255, 255, 255, 0.01)',

  // White variations for dark theme
  white: '#121212', // Dark background
  white10: '#1e1e1e', // Slightly lighter dark
  white20: 'rgba(255, 255, 255, 0.05)', // Very subtle white overlay
  white50: 'rgba(255, 255, 255, 0.12)', // Subtle white overlay

  // Actual white for text
  black: '#ffffff',

  // Background variations
  backgroundLight: '#181818', // Dark background
  lotion: '#1a1a1a',
  paleWhite: '#1c1c1c',
  greySeaShell: '#1f1f1f',
  greySaturated: '#121212',
  gray10: '#2a2a2a',
  gray99: '#161616',
  greyBackground: '#1a1a1a',
  grayBackground: '#181818',
  magnolia: '#1a1a1a',

  // Borders and dividers
  grayLine: '#333333',
  greyBorder: '#404040',
  dividerBorder: '#333333',
  groupDivider: '#1a1a1a',
  grayBorder: '#404040',
  lineGray: '#404040',
  alto: '#333333',

  // Text colors
  greyText: '#b0b0b0',
  grayDescription: '#a0a0a0',
  title: '#888888',
  eclipse: '#e0e0e0',
  sandGray: '#e0e0e0',
  grayLight: '#c0c0c0',
  silverChalice: '#909090',
  doveGray: '#b0b0b0',
  dimGray: '#c0c0c0',
  oldSilver: '#a0a0a0',
  darkSilver: '#b0b0b0',

  // Grays
  whiteSmoke: '#2a2a2a',
  gray88: '#404040',
  gray74: '#606060',
  gray62: '#707070',
  silverSonic: '#808080',
  grayDim: '#909090',
  gray92: '#2e2e2e',
  gray26: '#c0c0c0',
  gray13: '#e0e0e0',
  grayd9: '#404040',
  gray: '#808080',
  charcoal: '#e0e0e0',
  gray11: '#e0e0e0',
  gunmetal: '#d0d0d0',
  chineseSilver: '#606060',
  lightgray: '#303030',
  cyanBlue: '#404040',

  // Keep semantic colors similar but adjusted for dark theme
  danger: '#ff6b6b',
  success: '#51cf66',
  warning: '#ffd43b',
  info: '#74c0fc',
  red: '#ff6b6b',
  green10: '#69db7c',
  ChateauGreen: '#69db7c',
  classicGreen: '#51cf66',
  maniacGreen: '#40c057',
  delGreen: '#69db7c',
  redLight: '#ff8787',

  // Interactive elements
  selectedBg: 'rgba(83, 136, 216, 0.15)',
  iconBlue: '#74c0fc',
  blueShadow: 'rgba(116, 192, 252, 0.2)',
  azureishWhite: '#1a2332',
  linkBackground: '#1a2332',
  activeBtn: '#1a2332',
  hoverMenu: '#1f2937',
  hoverBlue: '#1a2332',
  hoverBtn: '#2a2a2a',
  darkBlue: '#74c0fc',
  lightBlueText: '#74c0fc',
  electricBlue: '#22d3ee',
  borderBlue: '#74c0fc',
  blueBorder: '#74c0fc',
  dodgerBlue: '#74c0fc',
  blueMagenta: '#e0e0e0',
  potterBlue: '#a5b4fc',

  // Special colors
  grayPlaceholder: '#606060',
  lavenderBlush: '#2a1a1a',
  jellyBean: '#ff6b6b',
  philippineGray10: '#b0b0b0',
  semiTransparentBlack2: 'rgba(255, 255, 255, 0.1)',
  paleWhite10: '#1e1e1e',
  lightGray10: '#404040',
  dimGray10: '#808080',
  gray80: 'rgba(200, 200, 200, 0.80)',
  black59: 'rgba(255, 255, 255, 0.59)',
  black85: 'rgba(255, 255, 255, 0.85)',
  black75: 'rgba(255, 255, 255, 0.75)',
  black57: 'rgba(255, 255, 255, 0.57)',
  black4: 'rgba(255, 255, 255, 0.04)',
  greyMercury: '#404040',
  CadetBlue: '#7dd3fc',
  yellowishBrown: '#fbbf24',
  darkGray: 'rgba(200, 200, 200, 1)',
  darkWashedRed: 'rgba(255, 100, 100, 0.2)',
  transparentBlack: 'rgba(255, 255, 255, 0.04)',
};

// Backward compatibility - defaults to light theme
export const colors = lightColors;

export const categoryColors = {
  comparision: '#EC9516',
  collection: '#517FB0',
  conversion: '#B69A07',
  dateOrTime: '#61A79F',
  geography: '#846058',
  inputData: '#6E4DB5',
  logic: '#968C2F',
  dataLookup: '#C88366',
  math: '#75B227',
  text: '#757575',
  photo: '#EF7D7D',
  defaultColor: '#949494',
};
export const BadgeColors = {
  salmonPink: '#FF7373',
  salmonPink15: 'rgba(255, 115, 115, 0.15)',
  skyBlue: '#4FC3CA',
  skyBlue15: 'rgba(79, 195, 202, 0.15)',
  cornflowerBlue: '#5E7ADF',
  cornflowerBlue15: 'rgba(94, 122, 223, 0.15)',
  steelBlue: '#67B4E1',
  steelBlue15: 'rgba(103, 180, 225, 0.15)',
  peach: '#FFA869',
  peach15: 'rgba(255, 177, 120, 0.15)',
  slateGray: '#60777C',
  slateGray15: 'rgba(96, 119, 124, 0.15)',
  sageGreen: '#70A485',
  sageGreen15: 'rgba(112, 164, 133, 0.15)',
  lavenderPurple: '#9B82D1',
  lavenderPurple15: 'rgba(155, 130, 209, 0.15)',
};
